import Immutable from 'immutable';
import {
  ProcessingStatus,
  ProcessingStatusList,
  RawProcessingStatus,
} from 'records/ProcessingStatus';
import GQLRequest from 'utils/GQLRequest';

export const getProcessingStatuses = async (
  projectid: string,
  onlySubmittals = false
): Promise<ProcessingStatusList> => {
  const resp: {
    getProcessingStatuses: RawProcessingStatus[];
  } = await new GQLRequest()
    .query(
      `
    query GetProcessingStatuses($projectid: String!, $onlySubmittals: Boolean) {
      getProcessingStatuses(projectid: $projectid, onlySubmittals: $onlySubmittals) {
        uploadTimestamp
        uploadedBy
        pagesProcessed
        pagesCount
        status
        reviewedtimestamp
        reviewedBy
        processingRequestid
        dmsProviderKind
        failedDocuments {
          documentid
          errorCode
          errorStage
        }
      }
    }
    `
    )
    .variables({ projectid, onlySubmittals })
    .json<{
      getProcessingStatuses: RawProcessingStatus[];
    }>();

  return Immutable.List(
    resp.getProcessingStatuses.map(ProcessingStatus.deserialize)
  );
};

export default {
  getProcessingStatuses,
};
